export enum EntityType {
  // Shared / Core
  USER = "USER",
  ROLE = "ROLE",
  BRANCH = "BRANCH",
  SCHOOL = "SCHOOL",
  ADDRESS = "ADDRESS",
  PERMISSION = "PERMISSION",
  BRANCH_SETTINGS = "BRANCH_SETTINGS",
  AUDIT_LOG = "AUDIT_LOG",
  NOTIFICATION = "NOTIFICATION",
  TEACHER_SUBJECT = "TEACHER_SUBJECT",
  TIMETABLE_JOB = "TIMETABLE_JOB",
  REPORT_CARD = "REPORT_CARD",

  // Procurement & Inventory
  SUPPLIER = "SUPPLIER",
  PURCHASE_ORDER = "PURCHASE_ORDER",
  PURCHASE_ORDER_ITEM = "PURCHASE_ORDER_ITEM",
  INVENTORY_ITEM = "INVENTORY_ITEM",
  STOCK_LEVEL = "STOCK_LEVEL",
  INVENTORY_LOG = "INVENTORY_LOG",

  // Finance & Cashflow
  PAYMENT = "PAYMENT",
  EXPENSE = "EXPENSE",
  INVOICE = "INVOICE",

  UNALLOCATED_PAYMENT = "UNALLOCATED_PAYMENT",

  // SMIS Specific Academics & Students
  STUDENT = "STUDENT",
  PARENT_GUARDIAN = "PARENT_GUARDIAN",
  TEACHER = "TEACHER",
  ENROLLMENT = "ENROLLMENT",
  CLASSROOM = "CLASSROOM",
  ACADEMIC_YEAR = "ACADEMIC_YEAR",
  TERM = "TERM",
  SUBJECT = "SUBJECT",
  GRADE_LEVEL = "GRADE_LEVEL",
  TIMETABLE = "TIMETABLE",
  TIMETABLE_SLOT = "TIMETABLE_SLOT",
  ASSESSMENT = "ASSESSMENT",
  ASSESSMENT_SCORE = "ASSESSMENT_SCORE",
  STUDENT_TERM_REPORT = "STUDENT_TERM_REPORT",
  BANK_TRANSACTION_STAGING = "BANK_TRANSACTION_STAGING",
  TIMESLOT = "TIMESLOT",
  ATTENDANCE_RECORD = "ATTENDANCE_RECORD",
  CURRICULUM_REQUIREMENT = "CURRICULUM_REQUIREMENT",
  TRANSITION_RECORD = "TRANSITION_RECORD",

  // SMIS Specific Fees
  FEE_STRUCTURE = "FEE_STRUCTURE",
  VOTE_HEAD = "VOTE_HEAD",
  STUDENT_FEE_LEDGER = "STUDENT_FEE_LEDGER",
  STUDENT_FEE_ALLOCATION = "STUDENT_FEE_ALLOCATION",

  // Communications
  COMMUNICATION_INTEGRATION = "COMMUNICATION_INTEGRATION",
  PAYMENT_INTEGRATION = "PAYMENT_INTEGRATION",
  SMS_OUTBOX = "SMS_OUTBOX",
  SMS_TEMPLATE = "SMS_TEMPLATE",
  WHATSAPP_MESSAGE = "WHATSAPP_MESSAGE",
  WHATSAPP_CONVERSATION = "WHATSAPP_CONVERSATION",
  NEWSLETTER = "NEWSLETTER",
  ANNOUNCEMENT = "ANNOUNCEMENT",
}
